import React, { useMemo } from 'react'
import InputField from '../../../../../FormControl/input/InputField'
import Typography from '@mui/material/Typography'
import {
  Box,
  Chip,
  Divider,
  FormControlLabel,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@mui/material'
import SelectCurriculum from '../../SelectCustom/SelectCurriculum'
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField'
import SelectField from '../../../../../FormControl/input/SelectField'
import InputColor from '../../../../../FormControl/input/InputColor'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import ChipRating from '../Ratings/ChipRating'

const FormRarting = ({ form = {}, errors = {}, onChange, type, curriculumList = [] }) => {
  const currentCurriculum = curriculumList?.find((item) => item._id === form?.curriculumId)

  const onAddRating = () => {
    const newRating = {
      _id: Date.now().toString(),
      name: `Rating ${form?.ratings?.length || 0 + 1}`,
      primaryColor: '#F8FDFF',
      secondaryColor: 'rgb(0, 55, 77)'
    }
    onChange('ratings', [...(form?.ratings || []), newRating])
  }

  const onRemoveRating = (index) => {
    const updatedRatings = [...(form?.ratings || [])]
    updatedRatings.splice(index, 1)
    onChange('ratings', updatedRatings)
  }

  return (
    <>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Code
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.code}</Typography>
        ) : (
          <InputField
            id='code'
            name='code'
            value={form.code}
            error={errors?.code}
            helperText={errors?.code}
            onChange={(e) => onChange('code', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Name
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.name}</Typography>
        ) : (
          <InputField
            id='name'
            name='name'
            value={form.name}
            error={errors?.name}
            helperText={errors?.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
            disabled={type === 'preview'}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Description
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.description}</Typography>
        ) : (
          <InputField
            id='description'
            name='description'
            value={form.description}
            error={errors?.description}
            helperText={errors?.description}
            onChange={(e) => onChange('description', e.target.value)}
            fullWidth
            multiline={true}
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        View
      </Typography>
      <div className='col-span-3 flex-col gap-2'>
        <div>
          <FormControlLabel
            control={
              <Switch
                checked={form?.view?.includes('by-assessment-area')}
                onChange={() =>
                  onChange(
                    'view',
                    form?.view?.includes('by-assessment-area')
                      ? form?.view?.filter((item) => item !== 'by-assessment-area')
                      : [...(form?.view || []), 'by-assessment-area']
                  )
                }
                color='primary'
                size='small'
              />
            }
            label='By assessment area'
            labelPlacement='end'
          />
        </div>
        <div>
          <FormControlLabel
            control={
              <Switch
                checked={form?.view?.includes('by-student')}
                onChange={() =>
                  onChange(
                    'view',
                    form?.view?.includes('by-student')
                      ? form?.view?.filter((item) => item !== 'by-student')
                      : [...(form?.view || []), 'by-assessment-area']
                  )
                }
                color='primary'
                size='small'
              />
            }
            label='By student'
            labelPlacement='end'
          />
        </div>
      </div>
      <Box className='col-span-full  '>
        <Box className='px-4 py-2 bg-primary text-primary-foreground font-bold uppercase flex items-center justify-between'>
          <Typography fontWeight='bold'>Ratings</Typography>

          <div>
            {type !== 'preview' && (
              <IconTooltipButton
                title='Add rating'
                icon={['fas', 'plus']}
                onClick={onAddRating}
                color='secondary'
                style={{ marginLeft: 10 }}
              />
            )}
          </div>
        </Box>
        <Box className='py-2'>
          <Table>
            <TableBody>
              {form?.ratings?.map((item, index) => (
                <TableRow key={item._id || index}>
                  <TableCell className='font-bold py-2'>
                    <div className='flex gap-2 items-center'>
                      <ChipRating key={index} {...item} />
                    </div>
                  </TableCell>
                  {type !== 'preview' && (
                    <TableCell className='font-bold'>
                      <div className='flex gap-2 items-center'>
                        <InputField
                          id={`rating-name-${index}`}
                          name={`rating-name-${index}`}
                          value={item.name}
                          error={errors?.[`rating-name-${index}`]}
                          helperText={errors?.[`rating-name-${index}`]}
                          onChange={(e) => {
                            const updatedRatings = [...(form?.ratings || [])]
                            updatedRatings[index].name = e.target.value
                            onChange('ratings', updatedRatings)
                          }}
                          fullWidth
                          disabled={type === 'preview'}
                        />
                        <InputColor
                          id={`primary-color-${index}`}
                          name={`primary-color-${index}`}
                          value={item.primaryColor}
                          short={true}
                          showDelete={false}
                          onChange={(color) => {
                            const updatedRatings = [...(form?.ratings || [])]
                            updatedRatings[index].primaryColor = color
                            onChange('ratings', updatedRatings)
                          }}
                          disabled={type === 'preview'}
                        />
                        <InputColor
                          id={`secondary-color-${index}`}
                          name={`secondary-color-${index}`}
                          value={item.secondaryColor}
                          short={true}
                          showDelete={false}
                          onChange={(color) => {
                            const updatedRatings = [...(form?.ratings || [])]
                            updatedRatings[index].secondaryColor = color
                            onChange('ratings', updatedRatings)
                          }}
                          disabled={type === 'preview'}
                        />
                      </div>
                    </TableCell>
                  )}
                  {type !== 'preview' && (
                    <TableCell className='font-bold' align='right'>
                      <IconTooltipButton
                        title='Delete rating'
                        icon={['fas', 'trash-alt']}
                        onClick={() => onRemoveRating(index)}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </>
  )
}

export default FormRarting
